import { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'platforma_ssm_theme';

const ThemeContext = createContext({ theme: 'light', toggle: () => {}, setTheme: () => {} });

// Persistență pe sesiune (sessionStorage): se păstrează la refresh, se resetează
// la logout (AuthContext curăță cheia) sau la închiderea tab-ului / noului login.
// Default mereu 'light' — nu folosim localStorage, nu detectăm preferința OS.
const getInitialTheme = () => {
  try {
    // Curăță valori vechi salvate în localStorage de versiuni anterioare
    localStorage.removeItem(STORAGE_KEY);
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch {}
  return 'light';
};

const applyThemeToDOM = (theme) => {
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
  root.style.colorScheme = theme;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    applyThemeToDOM(theme);
    try {
      sessionStorage.setItem(STORAGE_KEY, theme);
    } catch {}
  }, [theme]);

  const setTheme = (next) => {
    if (next === 'dark' || next === 'light') setThemeState(next);
  };
  const toggle = () => setThemeState((t) => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme }}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
